import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModules } from './material-modules';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomPaginator } from '../core/components/custom-paginator/custom-paginator';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    MaterialModules, FormsModule, ReactiveFormsModule,
    CustomPaginator,
    RouterModule
  ],
  exports: [CommonModule, MaterialModules, CustomPaginator,
    // FormsModule, ReactiveFormsModule
  ]
})
export class SharedModule {}
